import type * as React from 'react';
import { css } from '@emotion/react';

type OverflowType = 'auto' | 'hidden' | 'scroll' | 'visible';

const containerStyle = (overflow: OverflowType) => css`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
	overflow: ${overflow};
`;

type props = {
	overflow?: OverflowType;
	children: React.ReactNode;
};

const Container: React.FC<props> = ({ overflow = 'auto', children }) => {
	return <div css={containerStyle(overflow)}>{children}</div>;
};

export default Container;
